import { useEffect, useState } from 'react';
import { superAdminApi } from '../../lib/superAdminApi';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Loader2, ScrollText } from 'lucide-react';

const actionColor = (a) => {
  if (a.includes('deleted')) return 'text-red-300';
  if (a.includes('suspended')) return 'text-amber-300';
  if (a.includes('impersonate')) return 'text-purple-300';
  if (a.includes('created') || a.includes('activated')) return 'text-emerald-300';
  return 'text-white/80';
};

export default function SuperAdminAuditLog() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    superAdminApi.auditLog({ limit: 200 }).then((r) => setEntries(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="sa-audit-log-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight flex items-center gap-3">
          <ScrollText className="w-8 h-8" style={{ color: '#5BB8E8' }} /> Audit log
        </h1>
        <p className="text-white/60 mt-1">Todas as acções super-admin (últimas 200)</p>
      </div>

      <Card className="bg-[#0D1B3E]/60 border-white/10 backdrop-blur-sm">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <span>{entries.length} entradas</span>
            <Badge variant="outline" className="border-white/20 text-white/70 text-xs">últimas 200</Badge>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {loading ? (
            <div className="p-12 text-center">
              <Loader2 className="w-8 h-8 mx-auto animate-spin" style={{ color: '#5BB8E8' }} />
            </div>
          ) : (
            <div className="divide-y divide-white/10">
              {entries.map((e) => (
                <div key={e.log_id} className="p-4 flex items-start gap-4 hover:bg-white/5 transition-colors">
                  <div className="text-xs text-white/50 font-mono w-40 shrink-0">
                    {new Date(e.at).toLocaleString('pt-PT')}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <Badge variant="outline" className={`border-white/20 font-mono text-xs ${actionColor(e.action)}`}>
                        {e.action}
                      </Badge>
                      {e.tenant_id && (
                        <span className="text-xs text-white/50">
                          tenant: <span className="font-mono text-white/80">{e.tenant_id}</span>
                        </span>
                      )}
                      {e.target_user_id && (
                        <span className="text-xs text-white/50">
                          user: <span className="font-mono text-white/80">{e.target_user_id}</span>
                        </span>
                      )}
                    </div>
                    <div className="text-xs text-white/60 mt-1">{e.super_admin_email}</div>
                    {e.details && Object.keys(e.details).length > 0 && (
                      <details className="mt-2 text-xs text-white/50">
                        <summary className="cursor-pointer hover:text-white/80">detalhes</summary>
                        <pre className="mt-2 p-2 bg-[#0a0e1a] rounded border border-white/10 overflow-x-auto text-white/70">
                          {JSON.stringify(e.details, null, 2)}
                        </pre>
                      </details>
                    )}
                  </div>
                </div>
              ))}
              {entries.length === 0 && (
                <div className="p-12 text-center text-white/50">Sem entradas de auditoria ainda.</div>
              )}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
